import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-wallet-icon',
  templateUrl: './circle-wallet-icon.component.html'
})
export class CircleWalletIconComponent {
}
